import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AdminRole = 'superadmin';

export type AdminProfile = {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role: AdminRole;
};

export type AdminAuthState = {
  token: string | null;
  admin: AdminProfile | null;
};

const initialState: AdminAuthState = {
  token: null,
  admin: null,
};

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    setCredentials(state, action: PayloadAction<{ token: string; admin: AdminProfile }>) {
      state.token = action.payload.token;
      state.admin = action.payload.admin;
    },
    logout(state) {
      state.token = null;
      state.admin = null;
    },
  },
});

export const { setCredentials, logout } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;
